var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.5 200C399.5 310.181 310.181 399.5 200 399.5C89.8192 399.5 0.5 310.181 0.5 200C0.5 89.8192 89.8192 0.5 200 0.5C310.181 0.5 399.5 89.8192 399.5 200ZM282.631 153.987L277.481 148.965C234.69 107.236 165.31 107.236 122.519 148.965L116.866 154.477C114.726 156.563 114.726 159.946 116.866 162.032L134.483 179.212C135.553 180.255 137.287 180.255 138.357 179.212L145.947 171.811C175.8 142.7 224.2 142.7 254.053 171.811L261.14 178.722C262.21 179.765 263.944 179.765 265.014 178.722L282.631 161.542C284.771 159.456 284.771 156.073 282.631 153.987ZM329.595 199.784L313.916 184.494C311.776 182.407 308.307 182.407 306.168 184.494L255.989 233.425C255.454 233.947 254.587 233.947 254.052 233.425L203.873 184.493C201.733 182.406 198.264 182.406 196.125 184.493L145.948 233.425C145.413 233.947 144.546 233.947 144.011 233.425L93.8321 184.493C91.6925 182.407 88.2236 182.407 86.084 184.493L70.4045 199.783C68.2649 201.869 68.2649 205.252 70.4045 207.338L141.106 276.283C143.246 278.37 146.715 278.37 148.854 276.283L199.032 227.352C199.567 226.83 200.434 226.83 200.969 227.352L251.147 276.283C253.287 278.37 256.756 278.37 258.895 276.283L329.595 207.339C331.735 205.253 331.735 201.87 329.595 199.784Z",
    fill: "#3396FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/_walletconnect.64a50faea0816ae07b5a41c2320aaa9a.svg";
export { ForwardRef as ReactComponent };